export const employeeHiringLink = {
  PHONE_PLACEHOLDER: '(00) 00000-0000',
  DOCUMENT_PLACEHOLDER: '000.000.000-00',
  'Account type': 'Tipo de conta',
  'Account number': 'Número da conta',
  'Account agency (without check digit)': 'Agência (sem dígito verificador)',
  'Account owner fullname': 'Nome completo do titular da conta',
  Add: 'Adicionar',
  'Add dependent': 'Adicionar dependente',
  'Add route': 'Adicionar trajeto',
  Address: 'Endereço',
  'Alternative document': 'RG',
  'Amount per day': 'Qtd. por dia',
  Asian: 'Amarela',
  Attention: 'Atenção',
  "Bachelor's degree completed": 'Superior completo',
  "Bachelor's degree incomplete": 'Superior incompleto',
  Back: 'Voltar',
  Birthdate: 'Data de nascimento',
  Black: 'Negra',
  'Check digit': 'Dígito verificador',
  Child: 'Filho/Filha',
  'Cisgender man': 'Homem cisgênero',
  'Cisgender woman': 'Mulher cisgênero',
  City: 'Cidade',
  'City of birth': 'Cidade de nascimento',
  'Click or drag to attach a file': 'Clique ou arraste para anexar um arquivo',
  'Common-law marriage': ' União estável',
  'Dependent name': 'Nome do dependente',
  Dependents: 'Dependentes',
  District: 'Bairro',
  Divorced: 'Divorciado(a)',
  'Do you really want to remove this dependent?':
    'Quer realmente remover este dependente?',
  'Do you really want to remove this route?':
    'Quer realmente remover este trajeto?',
  'Doctorate degree completed': 'Doutorado completo',
  'Doctorate degree incomplete': 'Doutorado incompleto',
  Document: 'CPF',
  Documents: 'Documentos',
  Edit: 'Editar',
  'Education level': 'Escolaridade',
  'Elementary school completed': 'Ensino fundamental completo',
  'Elementary school incomplete': 'Ensino fundamental incompleto',
  Email: 'E-mail',
  'Emergency contact': 'Contato de emergência',
  'Employment offer': 'Proposta de contratação',
  'Father fullname': 'Nome completo do pai',
  'Financial data': 'Dados bancários',
  'Financial institution': 'Instituição financeira',
  Finish: 'Finalizar',
  'Food voucher': 'Vale alimentação',
  Fullname: 'Nome completo',
  Grandparent: 'Avô/Avó',
  'High school completed': 'Ensino médio completo',
  'High school incomplete': 'Ensino médio incompleto',
  Indigenous: 'Indígena',
  'Invalid file type': 'Tipo de arquivo inválido',
  'Is this your first job?': 'É o seu primeiro emprego?',
  'Is your work permit digital?': 'Sua carteira de trabalho é digital?',
  'Issue date': 'Data de expedição',
  'Issuing authority': 'Órgão emissor',
  "It's in my interest to receive transportation voucher":
    'É de meu interesse receber vale transporte',
  'Lab coat size': 'Tamanho do jaleco',
  'Marital status': 'Estado civil',
  Married: 'Casado(a)',
  "Master's degree completed": 'Mestrado completo',
  "Master's degree incomplete": 'Mestrado incompleto',
  'Military service certificate number': 'Código de reservista',
  Mixed: 'Parda',
  'Mother fullname': 'Nome completo da mãe',
  Next: 'Próximo',
  'Next step': 'Próximo passo',
  No: 'Não',
  'No dependents added': 'Nenhum dependente adicionado',
  'No routes added': 'Nenhum trajeto adicionado',
  'Non binary': 'Não binário',
  'Not disclosed': 'Não informada',
  'Operator/line': 'Operadora/linha',
  'Operator/line code': 'Cód. da operadora/linha',
  Other: 'Outro',
  'Owner identification document': 'CPF do titular',
  Parent: 'Pai/Mãe',
  Partner: 'Cônjuge',
  'Personal data': 'Dados pessoais',
  Phone: 'Telefone',
  'Please, inform an integer value': 'Por favor, informe um valor inteiro',
  'Please, inform a valid date': 'Por favor, informe uma data válida',
  'Please, inform a valid digit': 'Por favor, informe um dígito válido',
  'Please, inform a valid document': 'Por favor, informe um CPF válido',
  'Please, inform a valid e-mail': 'Por favor, informe um email válido',
  'Please, inform a valid name': 'Por favor, informe um nome válido',
  'Please, inform a valid value': 'Por favor, informe um valor válido',
  'Please, inform a valid whatsapp number':
    'Por favor, informe um número válido de whatsapp',
  'Postal code': 'CEP',
  'Postgraduate studies completed': 'Pós graduação completo',
  'Postgraduate studies incomplete': 'Pós graduação incompleto',
  'Prefer not to answer': 'Prefiro não responder',
  Relationship: 'Relação',
  'Relationship level': 'Grau de parentesco',
  'Required documents': 'Documentos necessários',
  Remove: 'Remover',
  Select: 'Selecionar',
  Section: 'Seção',
  Series: 'Série',
  'Shirt size': 'Tamanho da camiseta',
  Sibling: 'Irmão/irmã',
  Single: 'Solteiro(a)',
  State: 'UF',
  'State of alternate document issuance': 'UF do RG',
  'The data of your proposal was successfully saved!':
    'Os dados da sua proposta foram salvos com sucesso!',
  'This employment offer refers to the position of <1>{{position}}</1>, with <3>{{employmentType}}</3> employment at the unit of <5>{{unit}}</5> and a salary of <7>{{salary}}</7>':
    'Esta proposta de contratação é referente a vaga de <1>{{position}}</1> sendo o tipo de contratação <3>{{employmentType}}</3> na unidade de <5>{{unit}}</5> com a remuneração de <7>{{salary}}</7>.',
  'This field is required': 'Este campo é obrigatório',
  'Ticket type': 'Tipo de bilhete',
  'Total value': 'Valor total',
  'Touch to attach a file': 'Toque para anexar um arquivo',
  'Transgender man': 'Homem transgênero',
  'Transgender woman': 'Mulher transgênero',
  'Transport/Company': 'Transporte/empresa',
  'Transport/Company type': 'Tipo de transporte/empresa',
  'Transportation routes': 'Trajetos de transporte',
  'Transportation voucher': 'Vale transporte',
  'Transportation voucher and benefits': 'Vale transporte e benefícios',
  Uniform: 'Uniforme',
  'Unit value': 'Valor unitário',
  'Upload the files required below Files without the <1>*</1> character are optional':
    'Faça upload dos arquivos requisitados abaixo. Arquivos sem o caractere "<1>*</1>" são opcionais.',
  "We couldn't find your offer Please try again later":
    'Não conseguimos recuperar sua proposta. Por favor, tente novamente mais tarde',
  'Which gender do you identify with?': 'Qual gênero você se identifica?',
  'Which race do you identify with?': 'Qual raça você se identifica?',
  White: 'Branca',
  Widowed: 'Viúvo(a)',
  '<0>Via</0>laser hiring process': 'Processo de contratação <0>Via</0>laser',
  'Voter registration card': 'Título de eleitor',
  Yes: 'Sim',
  'You can only attach one file!': 'Você só pode anexar um arquivo!',
  Zone: 'Zona',
  'Income tax': 'Imposto de renda',
  origin: 'Origem',
  Destination: 'Destino',
  'without document': 'Sem CPF',
  'Destination neighborhood': 'Bairro destino',
  'Origin neighborhood': 'Bairro origem',
  'Destination zip code': 'CEP destino',
  'Origin zip code': 'CEP origem',
  neighborhood: 'Digite o nome do bairro',
};
